import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  { path: 'login', redirectTo: 'auth/login' },
  {
    path: 'unsubscribe',
    loadComponent: () =>
      import('./validation/unsubscribe/unsubscribe.component').then((m) => m.UnsubscribeComponent),
  },
  {
    path: 'validation/:token',
    loadChildren: () => import('./validation/validation.routes').then((m) => m.VALIDATION_ROUTES),
  },
  {
    path: 'validation/:token/:step',
    loadChildren: () => import('./validation/validation.routes').then((m) => m.VALIDATION_ROUTES),
  },
  {
    path: 'bat/:token',
    loadChildren: () => import('./validation/bat.routes').then((m) => m.BAT_ROUTES),
  },
  {
    path: 'bat/:token/:step',
    loadChildren: () => import('./validation/bat.routes').then((m) => m.BAT_ROUTES),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
